import { driver } from "driver.js";
import "driver.js/dist/driver.css";
import "./resultsTour.css";

export function startResultsPageTour() {
  const steps = [
    {
      popover: {
        title: "Hướng dẫn nhanh",
        description:
          "Tour này tóm tắt luồng quản lý kết quả học tập: xem thống kê, lọc dữ liệu, import/export và kiểm tra bảng điểm.",
        side: "over",
        align: "center",
      },
    },
  ];

  const segments = [
    {
      selector: '[data-tour="results-header"]',
      title: "Tiêu đề trang",
      description: "Vùng tổng quan module kết quả học tập.",
      side: "bottom",
    },
    {
      selector: '[data-tour="results-header-guides"]',
      title: "Cụm nút hướng dẫn",
      description: "Mở tour nhanh hoặc tài liệu hướng dẫn HTML.",
      side: "left",
    },
    {
      selector: '[data-tour="results-stats"]',
      title: "Khối thống kê",
      description: "Theo dõi nhanh số bản ghi điểm, số lớp, số học viên và điểm trung bình.",
      side: "bottom",
    },
    {
      selector: '[data-tour="results-filter"]',
      title: "Bộ lọc và thao tác",
      description: "Lọc theo chi nhánh/khóa/lớp, import điểm và xuất CSV.",
      side: "bottom",
    },
    {
      selector: '[data-tour="results-table"]',
      title: "Bảng kết quả",
      description: "Bấm dòng để mở học bạ học viên, sửa hoặc xóa bản ghi điểm.",
      side: "top",
    },
  ];

  for (const seg of segments) {
    const el = document.querySelector(seg.selector);
    if (!el) continue;
    steps.push({
      element: el,
      popover: {
        title: seg.title,
        description: seg.description,
        side: seg.side,
      },
    });
  }

  if (steps.length <= 1) {
    window.alert("Không tìm thấy vùng để chạy hướng dẫn. Hãy tải lại trang và thử lại.");
    return;
  }

  const d = driver({
    showProgress: true,
    smoothScroll: true,
    stagePadding: 10,
    stageRadius: 14,
    overlayOpacity: 0.68,
    overlayColor: "#0f172a",
    popoverClass: "results-tour-popover",
    nextBtnText: "Tiếp",
    prevBtnText: "Trước",
    doneBtnText: "Xong",
    progressText: "Bước {{current}} / {{total}}",
    showButtons: ["next", "previous", "close"],
    steps,
  });

  d.drive();
}
